import React from "react";
import { Link } from "react-router-dom";
import { Star, ShieldCheck, Award, BadgeCheck } from "lucide-react";
import { company } from "../data/company";
import { useGoogleReviews } from "../hooks/useGoogleReviews";

/**
 * Compact trust-badges strip — placed directly under the navbar on all pages.
 * Shows social proof + certifications above the fold to break first-visit resistance.
 */
export function TrustBar() {
  const live = useGoogleReviews();
  // Only render Google numbers when the live API is actually configured AND returns data.
  const hasLive = !!(live?.configured && live.rating);
  const googleRating = hasLive ? live.rating.toFixed(1) : null;
  const googleCount = hasLive ? live.userRatingCount || null : null;

  const items = [
    {
      // Google — enkel tonen wanneer we live cijfers hebben. Anders algemene
      // link naar het profiel om ongefundeerde aantallen te voorkomen.
      label: hasLive
        ? `Google · ${googleRating}★${googleCount ? ` · ${googleCount} reviews` : ""}`
        : "Google Reviews",
      icon: <Star size={14} className="fill-m-orange text-m-orange" />,
      href: live?.googleMapsUri || "https://www.google.com/maps",
      testid: "trustbar-google",
    },
    {
      // Werkspot — badge + link; review-aantal blijft verborgen tot bevestigd.
      label: "Werkspot Pro",
      icon: <Star size={14} className="fill-m-orange text-m-orange" />,
      href: company.werkspot?.profileUrl,
      testid: "trustbar-werkspot",
    },
    {
      label: "VCA-gecertificeerde medewerkers",
      icon: <ShieldCheck size={14} className="text-m-petrol" />,
      testid: "trustbar-vca",
    },
    {
      label: `KvK ${company.kvk}`,
      icon: <BadgeCheck size={14} className="text-m-petrol" />,
      testid: "trustbar-kvk",
    },
    {
      label: "15+ jaar praktijkervaring",
      icon: <Award size={14} className="text-m-petrol" />,
      testid: "trustbar-experience",
    },
  ];

  return (
    <div className="hidden md:block bg-m-surface border-b border-m-border-soft" data-testid="trustbar">
      <div className="max-w-[1480px] mx-auto px-6 md:px-12 lg:px-20 py-2.5 flex items-center justify-center gap-6 text-xs text-m-text-2 flex-wrap">
        {items.map((it) =>
          it.href ? (
            <a
              key={it.testid}
              href={it.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 hover:text-m-navy transition-colors"
              data-testid={it.testid}
            >
              {it.icon}
              <span>{it.label}</span>
            </a>
          ) : (
            <span key={it.testid} className="inline-flex items-center gap-1.5" data-testid={it.testid}>
              {it.icon}
              <span>{it.label}</span>
            </span>
          )
        )}
      </div>
    </div>
  );
}

export default TrustBar;
